<script setup>
import ActionsModal from "@/components/hpo/dashboard/patientListItems/ActionsModal.vue";
import HpoPatientModal from "@/components/hpo/patientModal/HpoPatientModal.vue";
import {ref} from "vue";
import TriageWizard from "@/components/hpo/triage/TriageWizard.vue";
import TransportWizard from "@/components/hpo/transport/TransportWizard.vue";
import IdentificationWizard from "@/components/hpo/identification/IdentificationWizard.vue";
import HospitalRecordsWizard from "../hospitalRecords/HospitalRecordsWizard.vue";

const props = defineProps({
    hpo: {
        type: Object,
        required: true
    },
    member: {
        type: Object,
        required: true
    },
    countries: {
        type: Array,
        required: true,
    },
    patientList: {
        type: Array,
    }
});

const emits = defineEmits(['submitTransport']);

const actionsModalPatient = ref(false);
const patientModalData = ref(null);
const triageWizardVisible = ref(false);
const triageWizardPatientData = ref(null);
const transportWizardVisible = ref(false);
const transportWizardPatientData = ref(null);
const identificationWizardVisible = ref(false);
const identificationWizardPatientData = ref(null);
const hospitalRecordsWizardVisible = ref(false);
const hospitalRecordsWizardPatientData = ref(null);

function showPatientModal(modalData) {
    patientModalData.value = modalData;
}

function hidePatientModal() {
    patientModalData.value = null;
    hideActionsModal();
}

function showActionsModal(patient) {
    actionsModalPatient.value = patient;
}

function hideActionsModal() {
    actionsModalPatient.value = false;
}

function showTriageWizard(patient = null) {
    triageWizardVisible.value = true;
    triageWizardPatientData.value = patient;
}

function hideTriageWizard() {
    triageWizardVisible.value = false;
    triageWizardPatientData.value = null;
    hideActionsModal();
}

function showTransportWizard(patient = null) {
    transportWizardVisible.value = true;
    transportWizardPatientData.value = patient;
}

function hideTransportWizard() {
    transportWizardVisible.value = false;
    transportWizardPatientData.value = null;
    hideActionsModal();
}

function showIdentificationWizard(patient = null) {
    identificationWizardVisible.value = true;
    identificationWizardPatientData.value = patient;
}

function hideIdentificationWizard() {
    identificationWizardVisible.value = false;
    identificationWizardPatientData.value = null;
    hideActionsModal();
}

function showHospitalRecordsWizard(patient = null) {
    hospitalRecordsWizardVisible.value = true;
    hospitalRecordsWizardPatientData.value = patient;
}

function hideHospitalRecordsWizard() {
    hospitalRecordsWizardVisible.value = false;
    hospitalRecordsWizardPatientData.value = null;
    hideActionsModal();
}

defineExpose({
    showPatientModal,
    hidePatientModal,
    showActionsModal,
    hideActionsModal,
    showTriageWizard,
    hideTriageWizard,
    showTransportWizard,
    hideTransportWizard,
    showIdentificationWizard,
    hideIdentificationWizard,
});

function handleSubmitTransport() {
    emits('submitTransport');
}
</script>

<template>
    <ActionsModal v-if="actionsModalPatient"
                  :patient="actionsModalPatient"
                  :member="member"
                  @displayPatientModal="showPatientModal"
                  @displayTriageWizard="showTriageWizard"
                  @displayTransportWizard="showTransportWizard"
                  @displayIdentificationWizard="showIdentificationWizard"
                  @displayHospitalRecordsWizard="showHospitalRecordsWizard"
                  @close="hideActionsModal"/>

    <HpoPatientModal v-if="patientModalData"
                     :hpoId="hpo.id"
                     :data="patientModalData"
                     :countries="countries"
                     :member="member"
                     @submitTransport="handleSubmitTransport"
                     @close="hidePatientModal"/>

    <TriageWizard v-if="triageWizardVisible"
                  :hpoId="hpo.id"
                  :patientList="patientList"
                  :patientData="triageWizardPatientData"
                  @close="hideTriageWizard"/>

    <TransportWizard v-if="transportWizardVisible"
                     :hpoId="hpo.id"
                     :patientList="patientList"
                     :patientData="transportWizardPatientData"
                     @close="hideTransportWizard"/>

    <IdentificationWizard v-if="identificationWizardVisible"
                          :hpoId="hpo.id"
                          :patientList="patientList"
                          :patientData="identificationWizardPatientData"
                          :countries="countries"
                          @close="hideIdentificationWizard"/>

    <HospitalRecordsWizard v-if="hospitalRecordsWizardVisible"
                          :hpoId="hpo.id"
                          :patientList="patientList"
                          :patientData="hospitalRecordsWizardPatientData"
                          @close="hideHospitalRecordsWizard"/>
</template>
